"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTSlotCoversOnFastenerChange = void 0;
const three_1 = require("three");
// eslint-disable-next-line import/no-cycle
const types_1 = require("~/store/types");
const events_1 = require("~/utils/events");
const utils_1 = require("../../utils");
const Viewer_1 = __importDefault(require("../../Viewer"));
const typeUtils_1 = require("../../utils/typeUtils");
const SlotCoverSnappingFactory_1 = __importDefault(require("./SlotCoverSnappingFactory"));
function findClosestSlotToPosition(slots, position) {
    if (!slots || slots.length === 0) {
        return null;
    }
    let closestSlot = null;
    let minDistance = Infinity;
    slots.forEach((slot) => {
        if (slot.points && Array.isArray(slot.points)) {
            slot.points.forEach((point) => {
                if (utils_1.Utils.areVectorsEqual(point, position)) {
                    closestSlot = slot;
                    minDistance = 0;
                    return;
                }
                const distance = point.distanceToSquared(position);
                if (distance < minDistance) {
                    minDistance = distance;
                    closestSlot = slot;
                }
            });
        }
    });
    return closestSlot;
}
function findTSlotCoversConnectedToExtrusion(extrusion) {
    const covers = [];
    const viewer = Viewer_1.default.instance;
    if (!extrusion.connectedItems) {
        return covers;
    }
    extrusion.connectedItems.forEach((connectedItem) => {
        if (connectedItem.componentType === types_1.COMPONENT_TYPE.TSLOT_COVER) {
            const coverObject = viewer.getObjectById(connectedItem.uuid);
            if (coverObject) {
                covers.push(coverObject);
            }
        }
    });
    return covers;
}
function getFastenerPositionOnSlot(slot, extrusion, connection) {
    const fastenerPositions = [];
    const viewer = Viewer_1.default.instance;
    const coverItem = connection.items.find((item) => item.uuid !== extrusion.uuid && item.componentType === types_1.COMPONENT_TYPE.TSLOT_COVER);
    if (!coverItem) {
        return fastenerPositions;
    }
    const coverObject = viewer.getObjectById(coverItem.uuid);
    if (!coverObject) {
        return fastenerPositions;
    }
    const center = utils_1.Utils.getAABBoxCenter(coverObject);
    const projected = new three_1.Vector3();
    new three_1.Plane().setFromNormalAndCoplanarPoint(slot.normal, slot.surfacePoint).projectPoint(center, projected);
    fastenerPositions.push(projected);
    return fastenerPositions;
}
function updateTSlotCoverForFastener(cover, slot, extrusion, fastenerPositions) {
    const viewer = Viewer_1.default.instance;
    const slotCoverSnapping = SlotCoverSnappingFactory_1.default.getCoverSnapping(viewer, cover);
    if (cover.userData.tempCovers) {
        cover.userData.tempCovers.forEach((tempCover) => {
            viewer.getScene().remove(tempCover);
        });
        cover.userData.tempCovers.clear();
    }
    let intersectionPoint;
    if (fastenerPositions.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        intersectionPoint = fastenerPositions[0];
    }
    else {
        intersectionPoint = slot.surfacePoint.clone();
    }
    const success = slotCoverSnapping.snapToSlot(slot, extrusion, intersectionPoint, true);
    return success;
}
// eslint-disable-next-line import/prefer-default-export
function updateTSlotCoversOnFastenerChange(connection) {
    const viewer = Viewer_1.default.instance;
    if (!(connection === null || connection === void 0 ? void 0 : connection.items) || !Array.isArray(connection.items)) {
        return;
    }
    const extrusions = connection.items
        .filter((item) => item.itemType === types_1.ITEM_TYPE.EXTRUSION)
        .map((item) => viewer.getObjectById(item.uuid))
        .filter(typeUtils_1.isDefined);
    const updatedCovers = [];
    extrusions.forEach((extrusion) => {
        var _a;
        const slots = (_a = extrusion.getSlots()) !== null && _a !== void 0 ? _a : [];
        const covers = findTSlotCoversConnectedToExtrusion(extrusion);
        covers.forEach((cover) => {
            if (cover.position) {
                const closestSlot = findClosestSlotToPosition(slots, cover.position);
                if (closestSlot) {
                    const fastenerPositions = getFastenerPositionOnSlot(closestSlot, extrusion, connection);
                    const success = updateTSlotCoverForFastener(cover, closestSlot, extrusion, fastenerPositions);
                    if (success) {
                        updatedCovers.push(cover);
                    }
                }
            }
        });
    });
    if (updatedCovers.length > 0) {
        const events = updatedCovers.map((cover) => {
            var _a, _b, _c, _d, _e;
            return ({
                actionType: types_1.ACTION_TYPE.UPDATE,
                size: (_a = cover.getLength) === null || _a === void 0 ? void 0 : _a.call(cover),
                itemNumber: (_b = cover.partDetails) === null || _b === void 0 ? void 0 : _b.itemNumber,
                itemType: cover.type,
                position: cover.position,
                uuid: cover.uuid,
                connections: Viewer_1.default.instance.getDesignProMain().connectionManager.getRelatedConnections(cover),
                slicePlanes: cover.slicePlanes,
                geomkernelPanelSize: (_c = cover.getSize) === null || _c === void 0 ? void 0 : _c.call(cover),
                panelSize: (_d = cover.originalPanelSize) !== null && _d !== void 0 ? _d : (_e = cover.getSize) === null || _e === void 0 ? void 0 : _e.call(cover),
                rotation: {
                    x: cover.quaternion.x,
                    y: cover.quaternion.y,
                    z: cover.quaternion.z,
                    w: cover.quaternion.w,
                },
            });
        });
        document.body.dispatchEvent((0, events_1.updateItemsToBOMEvent)(events));
    }
}
exports.updateTSlotCoversOnFastenerChange = updateTSlotCoversOnFastenerChange;
